<script setup>
const emit = defineEmits(['open']);

const openSummary = event => {
  event.stopPropagation();
  emit('open');
};
</script>

<template>
  <button
    type="button"
    class="inline-flex items-center gap-1.5 rounded-lg bg-n-alpha-2 px-3 py-1.5 text-xs font-medium text-n-slate-12 outline outline-1 outline-n-container hover:bg-n-alpha-1"
    @click="openSummary"
  >
    <span class="i-lucide-sparkles size-3.5" />
    {{ $t('CONTACT_REPORTS.DETAIL.AI_SUMMARY_OPEN') }}
  </button>
</template>
